import * as types from './mutation-types'

export const loadSupplyFormOptions = ({ commit }, { buyerId, buyerType = 'shop' }) => {
  return new Promise((resolve, reject) => {
    commit(types.SET_LOADING, true)

    const storesRequest = buyerType === 'shop'
      ? window.axios.get(`get/shop/${buyerId}/stores`)
      : window.axios.get('get/stores/collection')

    const productsRequest = buyerType === 'shop'
      ? window.axios.get(`admin/get/shop/${buyerId}/product/collection`)
      : window.axios.get(`get/stores/${buyerId}/products/initialiaze`)

    Promise.all([
      storesRequest,
      productsRequest,
      window.axios.get('get/list/shop'),
    ])
      .then(([storesResponse, productsResponse, shopsResponse]) => {
        const storePayload = buyerType === 'shop'
          ? (storesResponse?.data?.shop_stores || [])
          : (Array.isArray(storesResponse?.data?.store)
              ? storesResponse?.data?.store
              : storesResponse?.data?.store?.data || [])

        const stores = storePayload
          .filter((store) => store?.id && store.id !== buyerId)
          .map((store) => ({
          ...store,
          supplier_type: 'store',
        }))

        const shops = (shopsResponse?.data?.shops || [])
          .filter((shop) => shop?.id && shop.id !== buyerId)
          .map((shop) => ({
            ...shop,
            supplier_type: 'shop',
          }))

        commit(types.SET_SUPPLIERS, [...shops, ...stores])

        let products = []
        if (buyerType === 'shop') {
          products = (productsResponse?.data?.shop_products || [])
            .map((item) => item?.product_sale_element)
            .filter(Boolean)
        } else {
          const responseData = productsResponse?.data
          const rawProducts = Array.isArray(responseData)
            ? responseData
            : responseData?.product_sale_element || responseData?.products || []

          products = rawProducts
            .map((item) => item?.product_sale_element || item)
            .filter(Boolean)
        }

        commit(types.SET_PRODUCTS, products)
        resolve({ storesResponse, productsResponse, shopsResponse })
      })
      .catch((err) => {
        reject(err)
      })
      .finally(() => {
        commit(types.SET_LOADING, false)
      })
  })
}

export const createSupplyRequest = (_, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('store/stock/supplies', data)
      .then((response) => {
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const fetchSupplyDetail = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    commit(types.SET_LOADING, true)

    window.axios.get(`get/${id}/stock/supplies/detail`)
      .then((response) => {
        commit(types.SET_SUPPLY_DETAIL, response?.data?.data || {})
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
      .finally(() => {
        commit(types.SET_LOADING, false)
      })
  })
}

export const validateSupplyRequest = (_, { id, lines, date, notes }) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`validate/${id}/stock/supplies`, {
      lines,
      date,
      notes,
    })
      .then((response) => {
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const loadSupplyStatuses = ({ commit }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('get/supply/status/enum')
      .then((response) => {
        commit(types.SET_SUPPLY_STATUSES, response?.data || [])
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
